import type { SponsoredBrandDTO, SponsoredBrandRequest } from '../types/sponsored-brands';

export type SponsoredBrandsEvent = {
  'sponsored_brand/FETCH_SPONSORED_BRANDS/init': SponsoredBrandRequest;
  'sponsored_brand/FETCH_SPONSORED_BRANDS/request': boolean;
  'sponsored_brand/FETCH_SPONSORED_BRANDS/success': SponsoredBrandDTO;
  'sponsored_brand/FETCH_SPONSORED_BRANDS/failure': boolean;
  'sponsored_brand/FETCH_SPONSORED_BRANDS/cancel': undefined;
  'sponsored_brand/RESET': undefined;
};

export const FETCH_SPONSORED_BRANDS = {
  init: 'sponsored_brand/FETCH_SPONSORED_BRANDS/init',
  request: 'sponsored_brand/FETCH_SPONSORED_BRANDS/request',
  success: 'sponsored_brand/FETCH_SPONSORED_BRANDS/success',
  failure: 'sponsored_brand/FETCH_SPONSORED_BRANDS/failure',
  cancel: 'sponsored_brand/FETCH_SPONSORED_BRANDS/cancel',
} as const;

export const SPONSORED_BRANDS_RESET = 'sponsored_brand/RESET' as const;
